const EmiDetailRow = ({ data }) => {
  const { title, subtitle } = data || {}

  return (
    <div className='ew-d-flex ew-justify-content-between ew-align-items-center'>
      <span className='ew-typography-small ew-fw-regular'>{title}</span>
      <span className='ew-typography-small ew-color-primary ew-fw-semi-bold'>{subtitle}</span>
    </div>
  )
}

export default EmiDetailRow
